import { useSelector } from 'react-redux';
import {
  useQuery,
  DocumentNode,
  ApolloError,
  ApolloQueryResult,
  OperationVariables,
} from '@apollo/client';
import { RootState } from '../../../../store/store';
import { TextInput } from '../../../../types/schema/utils.types';
import { PaymentsRevenueObjType } from '../../../../types/schema/payment.types';

interface GetAllPaymentsRevenueByRangeHook {
  data: PaymentsRevenueObjType | undefined;
  loading: boolean;
  error: ApolloError | undefined;
  refetch: (variables?: Partial<OperationVariables> | undefined) => Promise<
    ApolloQueryResult<{
      getAllPaymentsRevenueByRange: PaymentsRevenueObjType;
    }>
  >;
}

interface GetAllPaymentsRevenueByRangeMutationData {
  getAllPaymentsRevenueByRange: PaymentsRevenueObjType;
}

interface GetAllPaymentsRevenueByRangeInputType {
  input: TextInput;
}

export function useGetAllPaymentsRevenueByRange(
  query: DocumentNode,
  input: TextInput
): GetAllPaymentsRevenueByRangeHook {
  const { jwt } = useSelector((state: RootState) => state.auth);

  const { data, loading, error, refetch } = useQuery<
    GetAllPaymentsRevenueByRangeMutationData,
    GetAllPaymentsRevenueByRangeInputType
  >(query, {
    variables: {
      input,
    },
    context: {
      headers: {
        cookie: `jwt=${jwt}`,
        authorization: jwt ? `Bearer ${jwt}` : '',
      },
    },
  });

  return {
    data: data?.getAllPaymentsRevenueByRange,
    loading,
    error,
    refetch,
  };
}
